import React from 'react';
import { useRouter } from 'next/router';
import { toRouterQuery } from '@dotone/react-ui-core/utils';
import { isEmpty } from 'lodash';
import FilterForm from './StatSummaryFilterForm';
import StatSummary from './StatSummary';

const StatSummaryPage = (props) => {
  const router = useRouter();

  const handleSubmitFilter = (values) => {
    router.push({ pathname: router.pathname, ...toRouterQuery(values) }, undefined, {
      shallow: true,
    });
  };

  if (isEmpty(router.query)) {
    const reportType = props.dateType === 'recordedAt' ? 'performance' : props.reportType;
    return <FilterForm reportType={reportType} onSubmit={handleSubmitFilter} />;
  }

  return <StatSummary {...props} />;
};

export default StatSummaryPage;
